import { MATH_SYMBOLS } from '@/utils/okr-elements/math'

export const getRangePercentage = ({ min = 0, max = 100, step = 1, current = 0 } = {}) => {
  const diff = max - min
  const pointsCount = diff / step
  const pointsPassed = (current - min) / step
  return `${Math.round((pointsPassed * 100) / pointsCount)}${MATH_SYMBOLS.PERCENT}`
}
